import React, { useEffect } from "react";
import CmsPage from "../../components/CmsPage/CmsPage";
const IDENTIFIER = "grievance-redressal";
import { saveMegaMenu } from "../../features/MegaMenu/MegaMenuSlice";
import { useDispatch } from "react-redux";

const GrievanceRedressal = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    dispatch(saveMegaMenu(false));
  }, []);
  return (
    <div>
      <CmsPage identifier={IDENTIFIER} />
    </div>
  );
};

export default GrievanceRedressal;
